import { useMessagingChatLocationUnreadCountRetrieve } from "@sidegigllc/api/client";

export function useUnreadMessageCount(locationId: number | null | undefined): number {
  const { data } = useMessagingChatLocationUnreadCountRetrieve(locationId ?? -1, {
    query: { enabled: !!locationId },
  });
  return data?.unread_message_count ?? 0;
}
